import { queryOptions, useQuery } from '@tanstack/react-query';
import { useApiClient } from '../ApiProvider';
import { unwrap, type ApiClient } from '../client';
import type { components } from '../schema.gen';
import { queryKeys } from './keys';

export type TeamRep = components['schemas']['TeamRep'];
export type TeamView = components['schemas']['TeamView'];
export type RepRef = components['schemas']['RepRef'];

/** A supervisor's reps, by name. Searched in the browser, so no `q`. */
export function teamRepsQuery(api: ApiClient, view: TeamView) {
  return queryOptions({
    queryKey: queryKeys.teamReps(view),
    queryFn: async () =>
      (await unwrap(api.GET('/api/team/reps', { params: { query: { view } } }))).items,
  });
}

export function useTeamReps(view: TeamView) {
  return useQuery(teamRepsQuery(useApiClient(), view));
}

/**
 * One supervised rep's (or, for a pay viewer, one viewable person's) name, for
 * breadcrumbs, and whether the caller may read their pending pay.
 */
export function teamRepQuery(api: ApiClient, repId: string) {
  return queryOptions({
    queryKey: queryKeys.teamRep(repId),
    queryFn: () =>
      unwrap(api.GET('/api/team/reps/{rep_id}', { params: { path: { rep_id: repId } } })),
    staleTime: Infinity,
  });
}

export function useTeamRep(repId: string, enabled = true) {
  return useQuery({ ...teamRepQuery(useApiClient(), repId), enabled });
}
